import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { clinicServiceDeliveryModelsDataSource } from 'infrastructure/data-sources/clinic-service-delivery-models';

import type { IClinicServiceDeliveryModelItem } from 'infrastructure/data-sources/clinic-service-delivery-models';
import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IClinicServiceDeliveryModelItem['id'],
  IClinicServiceDeliveryModelItem
>[];

interface IClinicServiceDeliveryModelSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClinicServiceDeliveryModelSelectBox: React.FC<
  IClinicServiceDeliveryModelSelectBoxProps
> = (props) => {
  const dataSource = useMemo(() => clinicServiceDeliveryModelsDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClinicServiceDeliveryModelSelectBox;
